import {Badge} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import {TEAM_STATUS_CONFIG} from '../config';

import type {FirmUserRoleStatus} from '@sollapay/enums';
import type {FC} from 'react';

export interface TeamMemberStatusBadgeProps {
  status: FirmUserRoleStatus;
}

export const TeamMemberStatusBadge: FC<TeamMemberStatusBadgeProps> = ({status}) => {
  const {t} = useTranslation('team');
  const config = TEAM_STATUS_CONFIG[status];

  return (
    <Badge variant={config.variant} size="sm" dot>
      {t(config.labelKey)}
    </Badge>
  );
};
